<div style="background-image:url('assets/login.png');background-size:cover;background-position:center;position:fixed;height:100%;width:100%;margin-top:-10px;overflow:auto;"></div>
<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;position:relative;z-index:2;font-family:'Roboto', sans-serif;">
  <div class="install-container mdc-card mdc-card--outlined">
    <form (ngSubmit)="$event.preventDefault()" class="form-container" style="padding:16px; max-width:300px;">
      <div style="display:flex;flex-direction:column;align-items:flex-start;width:100%;">
        <div style="display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;">
          <i class="material-icons" aria-hidden="true" style="font-size:38px;color:#1976d2;">system_update</i>
          <div style="text-align:left;margin-left:8px;">
            <div><b>Install HSI Training</b></div>
            <small>Video Player</small>
          </div>
        </div>
        <div style="font-size:14px;margin-top:16px; text-align:left;border-top:solid 2px #f1f1f1; padding-top:16px;">
          The HSI Training Video Player App can be installed to your device for quick and easy access to your Playlist Content.
          <br/><br/>
          @if (installable) {
            <span>Click the link below and follow the onscreen instructions to continue.</span>
          }
          @if (iosPrompt) {
            <span>
              Just tap <span class="material-icons" style="color:#1976d2">ios_share</span> then 'Add to Home Screen'.
            </span>
          }
        </div>
      </div>
      @if (iosPrompt) {
        <div>
          <img src="assets/ios_install.jpg" style="max-width:100%; border-radius:8px;margin-top:24px;border:solid 1px #777;"/>
        </div>
      }
      @if (installable) {
        <button type="submit" class="mdc-button mdc-button--raised" style="margin-top:20px;width:100%;" (click)="installApp()">
          <div class="mdc-button__ripple"></div>
          <span class="mdc-button__label clip">Install</span>
        </button>
      }
    </form>
  </div>
</div>